import { z } from 'zod';

export const InputSchema = z.object({
    prompts: z.object({
        notificationList: z.array(z.object({ active: z.boolean(), name: z.string() })),
    }),
});

export type ApproveNotificationType = z.infer<typeof InputSchema>;
